import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";
import getAxiosInstance from "./../../Utils/axios";
import { DateTime } from "luxon";
import ShowScreens from "../../Components/ShowScreens";
import MediaPreview from "../../Components/MediaPreview";
import ShowScreenDetails from "../../Components/ShowScreenDetails";
import {
  getCountries,
  getStates,
  getCities,
  getBuildings,
  getFloors,
  getScreens,
  getIdList,
} from "./../../Utils/api";
import ScreenShow from "../../Components/ScreenShow";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export default function ScreenStatus() {
  const [campaigns, setUserLog] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchFilter, setSearchFilter] = useState("");
  const [searchByType, setSearchByType] = useState("");
  const [limit, setLimit] = useState(20);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalUserLog, setTotalUserLog] = useState(0);

  const [notAdmin, setNotAdmin] = useState(false);

  // Location
  const [country, setCountry] = useState([]);
  const [inputCountry, setInputCountry] = useState("");
  const [state, setState] = useState([]);
  const [inputState, setInputState] = useState("");
  const [city, setCity] = useState([]);
  const [inputCity, setInputCity] = useState("");
  const [building, setBuilding] = useState([]);
  const [inputBuilding, setInputBuilding] = useState("");
  const [floor, setFloor] = useState([]);
  const [inputFloor, setInputFloor] = useState("");
  const [screen, setScreen] = useState([]);
  const [inputScreen, setInputScreen] = useState("");

  const fetchCountryData = (inputValue) => getCountries(inputValue);
  const fetchStateData = (inputValue) =>
    getStates(inputValue, getIdList(country));
  const fetchCityData = (inputValue) =>
    getCities(inputValue, getIdList(country), getIdList(state));
  const fetchBuildingData = (inputValue) =>
    getBuildings(
      inputValue,
      getIdList(country),
      getIdList(state),
      getIdList(city)
    );
  const fetchFloorData = (inputValue) =>
    getFloors(
      inputValue,
      getIdList(country),
      getIdList(state),
      getIdList(city),
      getIdList(building)
    );
  const fetchScreenData = (inputValue) =>
    getScreens(
      inputValue,
      getIdList(country),
      getIdList(state),
      getIdList(city),
      getIdList(building),
      getIdList(floor)
    );

  const getUserLog = () => {
    let jsonData = {
      limit: limit,
      page: pageNumber * limit,
      search: searchFilter,
      filter_by: searchByType,
      country: getIdList(country),
      state: getIdList(state),
      city: getIdList(city),
      building: getIdList(building),
      floor: getIdList(floor),
      screen: getIdList(screen),
    };
    // converting (json --> form-urlencoded)
    const data = Object.keys(jsonData)
      .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
      .join("&");

    getAxiosInstance()
      .post("/admin/screen-status-report", data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        setIsLoading(false);
        if (res.data.status === "success") {
          // console.log(res.data);
          setTotalUserLog(res.data.totalCount);
          setUserLog(res.data.result);
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot process request" });
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getUserLog();
  }, [
    limit,
    pageNumber,
    searchByType,
    country,
    state,
    city,
    building,
    floor,
    screen,
  ]);

  const changePage = ({ selected }) => setPageNumber(selected);

  function millisToMinutesAndSeconds(millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    // return minutes + " Min";
  }

  useEffect(() => {
    getAxiosInstance()
      .get("/admin/me")
      .then((res) => {
        if (res.data.result.user_type !== "admin") {
          setNotAdmin(true);
          setCountry(res.data.result.location.country);
          setState(res.data.result.location.state);
          setCity(res.data.result.location.city);
          setBuilding(res.data.result.location.building);
          setFloor(res.data.result.location.floor);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-sm-6">
                <h1 className="m-0">Screen Management</h1>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-2"></div>
              <div className="col-md-2">
                <AsyncSelect
                  defaultOptions
                  cacheOption
                  isMulti
                  placeholder="Countries"
                  value={country}
                  isDisabled={notAdmin}
                  getOptionLabel={(e) => `${e.name} (${e.code})`}
                  getOptionValue={(e) => e._id}
                  loadOptions={fetchCountryData}
                  onInputChange={setInputCountry}
                  onChange={(e) => {
                    setCountry(e);
                    setState([]);
                    setCity([]);
                    setBuilding([]);
                    setFloor([]);
                  }}
                />
              </div>
              <div className="col-md-2">
                <AsyncSelect
                  defaultOptions
                  cacheOption
                  isMulti
                  isDisabled={notAdmin}
                  placeholder="States"
                  value={state}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e._id}
                  loadOptions={fetchStateData}
                  onInputChange={setInputState}
                  onChange={(e) => {
                    setState(e);
                    setCity([]);
                    setBuilding([]);
                    setFloor([]);
                  }}
                />
              </div>
              <div className="col-md-2">
                <AsyncSelect
                  defaultOptions
                  cacheOption
                  isMulti
                  isDisabled={notAdmin}
                  placeholder="Cities"
                  value={city}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e._id}
                  loadOptions={fetchCityData}
                  //onInputChange={setInputCity}
                  onChange={(e) => {
                    setCity(e);
                    setBuilding([]);
                    setFloor([]);
                  }}
                />
              </div>
              <div className="col-md-2">
                <AsyncSelect
                  defaultOptions
                  cacheOption
                  isMulti
                  isDisabled={notAdmin}
                  placeholder="Buildings"
                  value={building}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e._id}
                  loadOptions={fetchBuildingData}
                  onInputChange={setInputBuilding}
                  onChange={(e) => {
                    setBuilding(e);
                    setFloor([]);
                  }}
                />
              </div>
              <div className="col-md-2">
                <AsyncSelect
                  defaultOptions
                  cacheOption
                  isMulti
                  isDisabled={notAdmin}
                  placeholder="Floors"
                  value={floor}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e._id}
                  loadOptions={fetchFloorData}
                  onInputChange={setInputFloor}
                  onChange={(e) => {
                    setFloor(e);
                    setScreen([]);
                  }}
                />
              </div>
            </div>
            <div className="row justify-content-center mt-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div class="card-tools row" style={{ width: 400 }}>
                      <div className="col-4">
                        <select
                          className="form-control"
                          value={searchByType}
                          onChange={(e) => setSearchByType(e.target.value)}
                          style={{ width: "100%" }}
                        >
                          <option value="">All Media</option>
                          <option value="text">Text</option>
                          <option value="photo">Image</option>
                          <option value="video">Video</option>
                        </select>
                      </div>
                      <div className="col-8">
                        <AsyncSelect
                          defaultOptions
                          isDisabled={notAdmin}
                          cacheOption
                          isMulti
                          placeholder="Screens"
                          value={screen}
                          getOptionLabel={(e) => e.name}
                          getOptionValue={(e) => e._id}
                          loadOptions={fetchScreenData}
                          onInputChange={setInputScreen}
                          onChange={setScreen}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: 10 }}>SL No.</th>
                          <th>Screen Name</th>
                          <th>Screen ID</th>
                          <th>Campaign </th>
                          <th>Media</th>
                          <th>Date and Time</th>
                          <th>Campaign Duration</th>
                          <th>Status</th>
                          <th>Message</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={10}>Loading User Log ...</td>
                          </tr>
                        )}
                        {!isLoading && totalUserLog === 0 && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={10}>No User Log Found</td>
                          </tr>
                        )}

                        {campaigns?.map((campaign, i) => (
                          <tr key={i}>
                            <td>{i + 1}.</td>
                            <td>{campaign.screen?.name}</td>
                            <td>
                              <ShowScreenDetails
                                screen={campaign.screen}
                                Toast={Toast}
                                getAxiosInstance={getAxiosInstance}
                              />
                            </td>
                            <td>
                              <ScreenShow
                                campaign={campaign.campaign}
                                Toast={Toast}
                                getAxiosInstance={getAxiosInstance}
                                screenCount={0}
                                showCampaign={true}
                              />
                            </td>
                            <td>
                              <MediaPreview
                                type={campaign.media?.type}
                                text={campaign.media?.text}
                                images={campaign.media?.image}
                                video={campaign.media?.video}
                              />
                            </td>
                            {campaign.active === 0 ? (
                              <td></td>
                            ) : (
                              <td>
                                {DateTime.fromMillis(
                                  campaign.start_time
                                ).toFormat("h:mm a dd LLL yyyy")}{" "}
                                -{" "}
                                {DateTime.fromMillis(
                                  campaign.end_time
                                ).toFormat("h:mm a dd LLL yyyy")}
                              </td>
                            )}
                            <td>
                              {millisToMinutesAndSeconds(campaign.duration)}
                            </td>
                            <td>
                              {campaign.active === 0 ? (
                                <span className="text-danger">Failure</span>
                              ) : (
                                <span className="text-success">Success</span>
                              )}
                            </td>
                            <td>
                              {campaign.active === 0 ? campaign.message : ""}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix">
                    {totalUserLog > limit ? (
                      <ReactPaginate
                        previousLabel={"«"}
                        nextLabel={"»"}
                        pageCount={Math.ceil(totalUserLog / limit)}
                        onPageChange={changePage}
                        containerClassName={
                          "pagination pagination-sm m-0 float-right"
                        }
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        // previousClassName={"previous"}
                        previousLinkClassName={"page-link"}
                        // nextClassName={"next"}
                        nextLinkClassName={"page-link"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
